@if (corporateTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    <div formArrayName="ontvoeging">
      @for (item of ontvoeging.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control
              [label]="i === 0 ? 'Naam ontvoegde dochter' : ''"
              [required]="true"
              class="custom-input-250"
              formControlName="naamDochter"
              id="naamDochter-{{i}}"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-button
              (click)="showDialog(i)"
              [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
              icon="plus"
              type="secondary"
            >Meer gegevens
            </snelstart-ui-button>
            <snelstart-ui-button
              (click)="verwijderRij(i)"
              [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
              class="delete"
              icon="trash"
              iconType="light"
              id="buttonDelete-{{i}}"
              size="medium"
              type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button
    (click)="addRij()"
    class="snelstart-ui-button"
    icon="plus"
    id="cancel"
    type="link"
  >Vennootschap toevoegen
  </snelstart-ui-button>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="ontvoegingSpec" size="lg"
                                  title="Gegevens ontvoeging dochtermaatschappij">
    <snelstart-ui-dialog-header-content>
      Vul onderstaande informatie in op het tjdstip onmiddellijk voorafgaand aan de ontvoeging van de dochtermaatschappij.
    </snelstart-ui-dialog-header-content>
    <snelstart-ui-dialog-body>
      <div style="max-width: 90%">
        <form [formGroup]="formGroup">
          <div formArrayName="ontvoeging">
            @for (item of ontvoeging.controls; track item; let i = $index) {
              <div [formGroupName]="i">
                @if (i === index) {
                  @if (ontvoeging.controls[i]; as rowControl) {
                    <div class="row">
                      <div class="col col-1">
                        <p>Voor dochtermaatschappij opgeofferde bedrag</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [required]=true
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="voorDochterOpgeofferdeBedrag"
                          id="voorDochterOpgeofferdeBedrag-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div class="pt-3 pb-3">
                      <b>Onderlinge vorderingen en schulden</b>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Waardering vordering op dochter op balans moeder</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="waarderingOnderlingeVorderingDochter"
                          id="waarderingOnderlingeVorderingDochter-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Waardering corresponderende schuld op balans dochter</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="waarderingOnderlingSchuldDochter"
                          id="waarderingOnderlingSchuldDochter-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Waardering vordering die dochter had op moeder</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [required]=true
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="waarderingOnderlingeVorderingAndereMaatschappij"
                          id="waarderingOnderlingeVorderingAndereMaatschappij-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Waardering corresponderende schuld van moeder aan dochter</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="waarderingOnderlingeSchuldAndereMaatschappij"
                          id="waarderingOnderlingeSchuldAndereMaatschappij-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div class="pt-3 pb-3">
                      <b>Toepassing artikel 15ai Wet Vpb 1969 (interne overdracht van stille reserves)</b>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Is artikel 15ai Wet Vpb 1969 toegepast?</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-select-form-control
                          [options]="optionsJaNee"
                          class="custom-input-150"
                          formControlName="toepassing15ai"
                          id="toepassing15ai-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-select-form-control>
                      </div>
                    </div>

                    @if (item.get('toepassing15ai')?.value === true) {
                      <div class="row">
                        <div class="col col-1">
                          <p>Is het betreffende vermogensbestanddeel nog in bezit van de overnemer?</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-select-form-control
                            [options]="optionsJaNee"
                            class="custom-input-150"
                            formControlName="vermogensbestanddeel15aiInBezitOvernemer"
                            id="vermogensbestanddeel15aiInBezitOvernemer-{{i}}"
                            prefix="€"
                          >
                          </snelstart-ui-select-form-control>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col col-1">
                          <p>Heeft de overnemer het betreffende vermogensbestanddeel voorafgaand aan de ontvoeging vervreemd??</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-select-form-control
                            [options]="optionsJaNee"
                            class="custom-input-150"
                            formControlName="vermogensbestanddeel15aiInBezitOverdrager"
                            id="vermogensbestanddeel15aiInBezitOverdrager-{{i}}"
                            prefix="€"
                          >
                          </snelstart-ui-select-form-control>
                        </div>
                      </div>

                      <div>
                        <div class="row">
                          <div class="col col-1">
                            <p>Waarde economisch verkeer van het vermogensbestanddeel bij ontvoeging</p>
                          </div>
                          <div class="col-auto">
                            <snelstart-ui-number-form-control
                              [showAllDecimals]="false"
                              align="right"
                              class="custom-input-150"
                              formControlName="wevVermogensbestanddeelBijOntvoeging"
                              id="wevVermogensbestanddeelBijOntvoeging-{{i}}"
                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div class="row">
                          <div class="col col-1">
                            <p>Waardering van het vermogensbestanddeel bij gebruik tegenbewijs</p>
                          </div>
                          <div class="col-auto">
                            <snelstart-ui-number-form-control
                              [showAllDecimals]="false"
                              align="right"
                              class="custom-input-150"
                              formControlName="waarderingVermogensbestanddeelBijTegenbewijs"
                              id="waarderingVermogensbestanddeelBijTegenbewijs-{{i}}"
                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div class="row">
                          <div class="col col-1">
                            <p>Boekwaarde van het vermogensbestanddeel bij ontvoeging</p>
                          </div>
                          <div class="col-auto">
                            <snelstart-ui-number-form-control
                              [showAllDecimals]="false"
                              align="right"
                              class="custom-input-150"
                              formControlName="boekwaardeVermogensbestanddeelBijOntvoeging"
                              id="boekwaardeVermogensbestanddeelBijOntvoeging-{{i}}"
                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div class="row">
                          <div class="col col-1">
                            <p>Winst fiscale eenheid door overdracht vermogensbestanddeel</p>
                          </div>
                          <div class="col-auto">
                            <snelstart-ui-number-form-control
                              [showAllDecimals]="false"
                              align="right"
                              class="custom-input-150"
                              formControlName="winstFEdoorOverdrachtVermogensbestanddeel"
                              id="winstFEdoorOverdrachtVermogensbestanddeel-{{i}}"
                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                          </div>
                        </div>
                      </div>
                    }

                    <div class="pt-3 pb-3">
                      <b>Toepassing artikel 15aj Wet Vpb 1969 (herinvesteringsreserves)</b>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Heeft de overnemer bij de vervreemding van een vermogensbestanddeel een herinvesteringsreserve gevormd?</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-select-form-control
                          [options]="optionsJaNee"
                          class="custom-input-150"
                          formControlName="vormingHIRdoorOvernemerVanToepassing"
                          id="vormingHIRdoorOvernemerVanToepassing-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-select-form-control>
                      </div>
                    </div>

                    @if (item.get('vormingHIRdoorOvernemerVanToepassing')?.value === true) {
                      <div class="row">
                        <div class="col col-1">
                          <p>Is de betreffende herinvesteringsreserve al afgeboekt op een vervangend bedrijfsmiddel?</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-select-form-control
                            [options]="optionsJaNee"
                            class="custom-input-150"
                            formControlName="aanwendingHIRdoorOvernemer"
                            id="aanwendingHIRdoorOvernemer-{{i}}"
                            prefix="€"
                          >
                          </snelstart-ui-select-form-control>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col col-1">
                          <p>Winst fiscale eenheid vanwege vrijval door overnemer gevormde herinvesteringsreserve</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-number-form-control
                            [showAllDecimals]="false"
                            align="right"
                            class="custom-input-150"
                            formControlName="winstFEvanwegeVrijvalHIR"
                            id="winstFEvanwegeVrijvalHIR-{{i}}"
                            prefix="€"
                          >
                          </snelstart-ui-number-form-control>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col col-1">
                          <p>Waarde economisch verkeer vervangende bedrijfsmiddel bij ontvoeging</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-number-form-control
                            [showAllDecimals]="false"
                            align="right"
                            class="custom-input-150"
                            formControlName="wevVervangendeBedrijfsmiddelBijOntvoeging"
                            id="wevVervangendeBedrijfsmiddelBijOntvoeging-{{i}}"
                            prefix="€"
                          >
                          </snelstart-ui-number-form-control>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col col-1">
                          <p>Boekwaarde van vervangende bedrijfsmiddel bij ontvoeging</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-number-form-control
                            [showAllDecimals]="false"
                            align="right"
                            class="custom-input-150"
                            formControlName="boekwaardeVervangendeBedrijfsmiddelBijOntvoeging"
                            id="boekwaardeVervangendeBedrijfsmiddelBijOntvoeging-{{i}}"
                            prefix="€"
                          >
                          </snelstart-ui-number-form-control>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col col-1">
                          <p>Winst fiscale eenheid door herwaardering vervangende bedrijfsmiddel bij ontvoeging</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-number-form-control
                            [showAllDecimals]="false"
                            align="right"
                            class="custom-input-150"
                            formControlName="winstFeDoorHerwaarderingVervangendeBedrijfsmiddel"
                            id="winstFeDoorHerwaarderingVervangendeBedrijfsmiddel-{{i}}"
                            prefix="€"
                          >
                          </snelstart-ui-number-form-control>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col col-1">
                          <p>Heeft de ontvoegende dochter een herinvesteringsreserve terwijl wordt vervanging door de moeder?</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-select-form-control
                            [options]="optionsJaNee"
                            class="custom-input-150"
                            formControlName="hirOpBalansOntvoegdeDochter"
                            id="hirOpBalansOntvoegdeDochter-{{i}}"
                            prefix="€"
                          >
                          </snelstart-ui-select-form-control>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col col-1">
                          <p>Heeft de moeder een herinvesteringsreserve terwijl wordt vervanging door de ontvoegde dochter?</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-select-form-control
                            [options]="optionsJaNee"
                            class="custom-input-150"
                            formControlName="hirOpBalansOntvoegdeDochter"
                            id="hirOpBalansOntvoegdeDochter-{{i}}"
                            prefix="€"
                          >
                          </snelstart-ui-select-form-control>
                        </div>
                      </div>
                    }
                  }
                }
              </div>
            }
          </div>
        </form>
      </div>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
      <snelstart-ui-button class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
      <snelstart-ui-button icon="check" id="save" type="primary">
        Akkoord
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}
